import { EMPTY_CHARGE_WAIVER_REGISTRATION_MODEL } from "presentation/model/ChargeWaiverRegistration/ChargeWaiverRegistrationModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: ChargeWaiverRegistrationProvider,
    useTracked: useChargeWaiverRegistrationTracked
} = createContainer(() => useState(EMPTY_CHARGE_WAIVER_REGISTRATION_MODEL), { concurrentMode: true });
export { ChargeWaiverRegistrationProvider, useChargeWaiverRegistrationTracked };

